import { Navigate } from "react-router";
import { useAuthStore } from "@/auth/auth-store";
import { LandingPage } from "./landing-page";

/**
 * Route guard for the landing page (`/`).
 *
 * - Authenticated users → redirect to `/home`
 * - Unauthenticated users → render `<LandingPage />`
 *
 * SC-007: Redirect completes within 100ms (no flash of landing content).
 */
export function LandingGuard() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to="/home" replace />;
  }

  return <LandingPage />;
}
